import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import { useVisible } from "../../../utils/hooks/useVisible";

function BulkActions({ rows, selectedRows = [], openDenyModal, openApproveReasonModal, canApprove, canDeny }) {
	const { t } = useTranslation();

	const { visible, toggle } = useVisible();

	const ids = useMemo(() => {
		return Object.keys(rows);
	}, [rows]);

	const approveItemDisabled = useMemo(() => {
		if (ids.length === 0) {
			return true;
		}
		if (typeof canApprove !== "function") {
			return true;
		}
		return !selectedRows.every((row) => canApprove(row));
	}, [ids, canApprove, selectedRows]);

	const denyItemDisabled = useMemo(() => {
		if (ids.length === 0) {
			return true;
		}
		if (typeof canDeny !== "function") {
			return true;
		}
		return !selectedRows.every((row) => canDeny(row));
	}, [ids, canDeny, selectedRows]);

	return (
		<Dropdown isOpen={visible} toggle={toggle}>
			<span className="text-sm font-weight-600 text-dark mr-1 text-center">
				{t("selected")}{" "}
				<span
					className="text-sm rounded-circle py-1 px-2 mx-1"
					style={{ backgroundColor: "#ced4da" }}
				>
					{Object.keys(rows).length}
				</span>
			</span>
			<DropdownToggle
				className="btn-round btn-icon shadow-none border"
				size="sm"
			>
				{t("actions")}
			</DropdownToggle>
			<DropdownMenu>
				<DropdownItem onClick={() => openApproveReasonModal(ids)} disabled={approveItemDisabled}>
					{t("approve")}
				</DropdownItem>
				<DropdownItem onClick={() => openDenyModal(ids)} disabled={denyItemDisabled}>
					{t("deny")}
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
}

export default BulkActions;
